import { useContext, useEffect, useState } from 'react'
import { Avatar, Container, Divider, Grid, Stack, Typography } from '@mui/material'

import styles from './ProfileSuccessfulReferral.module.css'
import useTrackPageView from '../../../../helpers/hooks/use-track-page-view'
import { AppContext } from '../../../../stores/App/AppStore'
import CommonBackButton from '../../../atoms/CommonBackButton/CommonBackButton'
import { useReferralLandingPageRepository } from '../../../../repositories/ReferralLandingPage/use-referral-landing-page.repository'
import { UserContext } from '../../../../stores/User/UserStore'
import Spacer from '../../../atoms/Spacer/Spacer'
import BannerImage from '../../../atoms/BannerImage/BannerImage'
import { RefereeDetail } from '../../../../types'
import SkeletonLines from '../../../atoms/SkeletonLines/SkeletonLines'
import SuccessfulReferralCardContent from '../../../molecules/SuccessfulReferralCardContent/SuccessfulReferralCardContent'

const ProfileSuccessfulReferral = () => {
    useTrackPageView(`Profile Successful Referral`)

    const { state: appState } = useContext(AppContext)
    const { state: userState } = useContext(UserContext)
    const [refereeDetails, setRefereeDetails] = useState<RefereeDetail[]>()
    const { getReferralPage, getReferreeDetails } = useReferralLandingPageRepository()
    const referredUsers = userState.user?.data?.referredUsers

    useEffect(() => {
        getReferralPage()
        getReferreeDetailsOnEntry()
        window.scrollTo(0, 0)
    }, [])

    const getReferreeDetailsOnEntry = async () => {
        if (referredUsers){
            const data = await getReferreeDetails(referredUsers?.map(referee => referee.id.toString()))
            if (data){
                setRefereeDetails(data)
            }
        }
    }

    const userInitials = (name?: string): string => {
        if (name){
            const parts = name.toUpperCase().trim().split(/\W/)
            const firstCharacter = parts[0][0]
            const secondCharacter = parts.length > 1 && parts[1] ? parts[1][0] : ``

            return `${firstCharacter}${secondCharacter}`
        }
        else {
            return `??`
        }
    }

    return <Container>
        <CommonBackButton />
        <Grid item className={styles.membershipPlanBanner}>
            <BannerImage imageUrl={appState.pages.referralLandingPage.profileReferralBanner} className={styles.appLogo} alt="profile successful referral banner" />
        </Grid>
        {(referredUsers?.length ?? 0) > 0 &&
            <SuccessfulReferralCardContent referredUsers={referredUsers}/>
        }
        {
            refereeDetails ?
                refereeDetails.map((refereeDetail) =>
                    <>
                        <Spacer height={10} />
                        <Divider />
                        <Spacer height={20} />
                        <Grid container spacing={1} direction="row" key={refereeDetail.fullName}>
                            <Grid item xs={3} className={styles.refereeProfilePic}>
                                <Avatar className={styles.avatar} src={refereeDetail.profileImageThumbnail}>{userInitials(refereeDetail.fullName)}</Avatar>
                            </Grid>
                            <Grid item xs={9} className={styles.refereeMembershipDetails}>
                                <Stack direction={`row`} className={styles.checkbox} justifyContent="space-between">
                                    <Typography>{refereeDetail.fullName}</Typography>
                                    <Typography>{refereeDetail.signUpDate}</Typography>
                                </Stack>
                            </Grid>
                        </Grid>
                    </>)
                : <SkeletonLines/>
        }
    </Container>
}

export default ProfileSuccessfulReferral